var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tecnicos"},[(_vm.tecnico)?_c('usuarios-form',{attrs:{"usuarioProp":_vm.tecnico}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }